import { Grid } from "@mui/material";

export default function AddMembers() {

    return (
        <>
            <Grid p={10}>
                <button className="btn btn-outline-dark float-end">Close</button>
            </Grid>

        </>
    )

}